/** Точка входа. Инициализация BX24.js выполняется внутри App. */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';
// Фирменный стиль портала — после общих стилей, чтобы мог их переопределить
import '@brand/theme.css';

const container = document.getElementById('root');
if (!container) throw new Error('Не найден элемент #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
